import React, { useState } from 'react';
import SocialMediaIcons from './SocialMediaIcons';
import { GrUserWorker } from "react-icons/gr";
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Carousel from './Carousel';
const serviceData = [
  { id: 1, title: 'Supply and installation of Natural Stone,Tiles', description: 'Description 1' },
  { id: 2, title: 'Wall Cladding', description: 'Description 3' },
  { id: 3, title: 'Counter and Vanity Tops', description: 'Description 4' },
 
];

const ServiceGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 20px;
  
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const ServiceCard = styled.div`
  flex: 0 0 calc(33.33% - 20px); /* 3 columns */

  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  background-color: #fff;
  text-align: center;
  border-radius: 8px;
  h3:hover{ cursor:pointer;
  color:#ce8e04;
  }
  
  @media (max-width: 768px) {
    flex: 0 0 calc(50% - 20px); /* 2 columns for smaller screens */
  }
  
  @media (max-width: 480px) {
    flex: 0 0 calc(100% - 20px); /* 1 column for mobile */
  }
`;

const Services = () => {
  const [services] = useState(serviceData);
  const nav=useNavigate()
  return (
      <div>
        
        
    <div className='servicehelo'>
  
    <div className="services">
      <h2 className="title">WHAT WE DO</h2>
      <p className="description">
      Welcome to SmartStone Marble Ind, your premier destination for exceptional marble flooring and a wide range of marble work solutions. With years of expertise and a passion for craftsmanship, we are dedicated to bringing the timeless beauty of marble into your spaces. Whether you’re looking to enhance your home or elevate a commercial project, our skilled team delivers high-quality, custom marble installations that reflect elegance and durability. At Smart Stone, we pride ourselves on providing outstanding service, ensuring every project meets the highest standards. Let us transform your vision into a stunning reality with the natural beauty of marble.      </p>

      <ServiceGrid>
      {services.map(service => (
        
        
        <ServiceCard className='fontforservice'  key={service.id}>
           <div className='worker-icon'> <GrUserWorker/></div>
          <h3 onClick={()=>nav(`/serviceDetails/${service.id}`)}>{service.title}</h3>
          
        </ServiceCard>
      ))}
    </ServiceGrid>
  
        </div>
      </div>
        
       
        <SocialMediaIcons/>
        
      </div>
     
    
  );
};

export default Services;